module.exports = __webpack_public_path__ + "static/media/8OLA22.ecba45d4.jpg";